import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, ShoppingBag, Newspaper, Map as MapIcon, Home } from 'lucide-react';

const Navbar = () => {
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (search.trim()) {
      navigate(`/stats/${search.trim()}`);
      setSearch('');
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 h-[var(--nav-height)] glass-card rounded-none border-t-0 border-x-0 flex items-center justify-between px-8">
      <Link to="/" className="flex items-center gap-2 no-underline">
        <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-blue-500 rounded-xl flex items-center justify-center font-bold text-white text-xl">F</div>
        <span className="font-bold text-xl tracking-tight hidden sm:block">FORT<span className="gradient-text">STATS</span></span>
      </Link>

      <form onSubmit={handleSearch} className="flex-1 max-w-md mx-8 relative">
        <input
          type="text"
          placeholder="Rechercher un joueur..."
          className="w-full bg-white/5 border border-white/10 rounded-full py-2 px-10 focus:outline-none focus:border-purple-500/50 transition-all text-sm"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40" />
      </form>

      <div className="flex items-center gap-6">
        <Link to="/" title="Accueil" className="text-white/60 hover:text-white transition-colors">
          <Home className="w-5 h-5" />
        </Link>
        <Link to="/shop" title="Boutique" className="text-white/60 hover:text-white transition-colors">
          <ShoppingBag className="w-5 h-5" />
        </Link>
        <Link to="/news" title="Actualités" className="text-white/60 hover:text-white transition-colors">
          <Newspaper className="w-5 h-5" />
        </Link>
        <Link to="/map" title="Carte" className="text-white/60 hover:text-white transition-colors">
          <MapIcon className="w-5 h-5" />
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
